
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire73bb"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire73bb"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bV0pP", function(module, exports) {

$parcel$export(module.exports, "OLCS_ION_TOKEN", () => $8ad5571f7dcc7a1a$export$97f9922ccba1277f);
const $8ad5571f7dcc7a1a$export$97f9922ccba1277f = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI3ZWVhYmU0Mi1jNTZkLTQ3OGItYmUxYS00YTMyMDQyZTMwNDkiLCJpZCI6NjQ1LCJpYXQiOjE2MDYxMjE2OTF9.zQibbf5P0-moQ8KiV_K7KMtyLHbR-VlPghj8lyqWduU";

});


var $bdrRp = parcelRequire("bdrRp");

var $bnthu = parcelRequire("bnthu");

var $inIMS = parcelRequire("inIMS");

var $wnhPR = parcelRequire("wnhPR");

var $c3RIb = parcelRequire("c3RIb");

var $cc3xD = parcelRequire("cc3xD");

var $9DiKA = parcelRequire("9DiKA");

var $5DwXE = parcelRequire("5DwXE");

var $9jDAx = parcelRequire("9jDAx");

var $4mWlF = parcelRequire("4mWlF");

var $dIG9p = parcelRequire("dIG9p");

var $9vPkX = parcelRequire("9vPkX");

var $bV0pP = parcelRequire("bV0pP");
let $428e7298e2ea34e1$var$total = 0;
let $428e7298e2ea34e1$var$created = 0;
let $428e7298e2ea34e1$var$added = 0;
const $428e7298e2ea34e1$var$vectorLayers = [];
const $428e7298e2ea34e1$var$tile = new (0, $4mWlF.default)({
    source: new (0, $9jDAx.default)()
});
const $428e7298e2ea34e1$var$map = new (0, $5DwXE.default)({
    layers: [
        $428e7298e2ea34e1$var$tile
    ],
    target: "map2d",
    view: new (0, $9DiKA.default)({
        center: [
            0,
            0
        ],
        zoom: 2
    })
});
Cesium.Ion.defaultAccessToken = (0, $bV0pP.OLCS_ION_TOKEN);
const $428e7298e2ea34e1$var$ol3d = new (0, $cc3xD.default)({
    map: $428e7298e2ea34e1$var$map
});
const $428e7298e2ea34e1$var$scene = $428e7298e2ea34e1$var$ol3d.getCesiumScene();
Cesium.createWorldTerrainAsync().then((tp)=>$428e7298e2ea34e1$var$scene.terrainProvider = tp);
$428e7298e2ea34e1$var$ol3d.setEnabled(true);
// Show off 3D feature picking
const $428e7298e2ea34e1$var$handler = new Cesium.ScreenSpaceEventHandler($428e7298e2ea34e1$var$scene.canvas);
let $428e7298e2ea34e1$var$lastPicked;
$428e7298e2ea34e1$var$handler.setInputAction((movement)=>{
    const pickedObjects = $428e7298e2ea34e1$var$scene.drillPick(movement.position);
    if (Cesium.defined(pickedObjects)) for(let i = 0; i < pickedObjects.length; ++i){
        const picked = pickedObjects[i].primitive;
        if (picked.olFeature == $428e7298e2ea34e1$var$lastPicked) continue;
        const carto = Cesium.Ellipsoid.WGS84.cartesianToCartographic(picked.position);
        console.log("Picked feature", picked.olFeature, " is at ", carto);
        $428e7298e2ea34e1$var$lastPicked = picked.olFeature;
    }
    else $428e7298e2ea34e1$var$lastPicked = undefined;
}, Cesium.ScreenSpaceEventType.LEFT_CLICK);
window["clearFeatures"] = function() {
    $428e7298e2ea34e1$var$vectorLayers.forEach((layer)=>{
        $428e7298e2ea34e1$var$map.getLayers().remove(layer);
    });
    $428e7298e2ea34e1$var$vectorLayers.length = 0;
    $428e7298e2ea34e1$var$total = document.getElementById("total").innerHTML = 0;
    document.getElementById("created").innerHTML = "";
    document.getElementById("added").innerHTML = "";
};
window["addFeatures"] = function() {
    let then = Date.now();
    const count = 1000;
    const features = [];
    const e = 18000000;
    for(let i = 0; i < count; ++i){
        const feature = new (0, $dIG9p.default)({
            geometry: new (0, $9vPkX.default)([
                2 * e * Math.random() - e,
                2 * e * Math.random() - e,
                e * Math.random()
            ])
        });
        const style = [
            new (0, $c3RIb.default)({
                image: new (0, $wnhPR.default)({
                    radius: 2,
                    fill: new (0, $inIMS.default)({
                        color: [
                            Math.random() * 255,
                            Math.random() * 255,
                            Math.random() * 255,
                            Math.random()
                        ]
                    })
                })
            })
        ];
        feature.setStyle(style);
        feature.setId(e * Math.random());
        features.push(feature);
    }
    let now = Date.now();
    $428e7298e2ea34e1$var$created = now - then;
    then = now;
    const vectorSource = new (0, $bnthu.default)({});
    const vector = new (0, $bdrRp.default)({
        source: vectorSource
    });
    vectorSource.addFeatures(features);
    $428e7298e2ea34e1$var$map.addLayer(vector);
    $428e7298e2ea34e1$var$vectorLayers.push(vector);
    now = Date.now();
    $428e7298e2ea34e1$var$added = now - then;
    $428e7298e2ea34e1$var$total += count;
    document.getElementById("total").innerHTML = $428e7298e2ea34e1$var$total;
    document.getElementById("created").innerHTML = `Features created in ${$428e7298e2ea34e1$var$created}ms.`;
    document.getElementById("added").innerHTML = `Features added in ${$428e7298e2ea34e1$var$added}ms.`;
};


//# sourceMappingURL=synthvectors.f73754c2.js.map
